/**
 * Tiny i18n helper for 3-language string choices used throughout the app.
 * Usage: tr(language, 'English text', 'Português', 'Español')
 */
export const tr = (language, en, pt, es) => {
  if (language === 'pt') return pt;
  if (language === 'es') return es;
  return en;
};
